import Menu from "./menu";

export default function Resume() {
  return (
    <>
      <div className="col-12 col-md-12 col-xl-9">
        <div className="box-outer">
          {/* <!-- Menu --> */}
          <Menu />
          <div className="pb-3">
            <h1 className="title title--h1 title__separate">
              Resume{" "}
              <a
                target="blank"
                href="https://drive.google.com/file/d/1bemhWB87ju0YNYPpVw99yn00N5gxdy4h/view?usp=sharing"
              >
                <i className="font-icon icon-download download"></i>
              </a>
            </h1>
          </div>

          <h2 className="title title--h2">
            <span className="box icon-box">
              <i className="font-icon feathericon-book-open"></i>
            </span>
            Education
          </h2>
          <div className="timeline">
            <article className="timeline__item">
              <h5 className="title title--h4 timeline__title">
                Waseda University
              </h5>
              <span className="timeline__period">2009 — 2013</span>
              <p className="timeline__description">
                Bachelor of Engineering | Computer Science and Communication Engineering
              </p>
            </article>
          </div>

          <h2 className="title title--h2">
            <span className="box icon-box">
              <i className="font-icon feathericon-briefcase"></i>
            </span>
            Experience
          </h2>
          <div className="timeline">
            <article className="timeline__item">
              <h5 className="title title--h4 timeline__title">
                Senior Blockchain Developer
              </h5>
              <h6 className="title title--h5 timeline__title">
                Upwork · Freelance
              </h6>
              <h6 className="title title--h5 timeline__title">
                Escondido, United States
              </h6>
              <span className="timeline__period">May 2021 — Present</span>
              <ul>
                <li>
                  <p className="timeline__description">
                    Reviewed client requirement, wireframes, and designs for technical feasibility
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Created and maintained supporting documentation for project
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Performed technical designs and implementation of 8+ blockchain projects: smart contracts and dapps 
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                  Improved product quality through code reviews, writing, 
                  effective unit tests and collaboration with QA on implementing automation testing
                  </p>
                </li>
              </ul>
            </article>

{/* Lead software developer */}
            <article className="timeline__item">
              <h5 className="title title--h4 timeline__title">
                Lead Software Developer
              </h5>
              <h6 className="title title--h5 timeline__title">
                Pon • Contract
              </h6>
              <h6 className="title title--h5 timeline__title">
               Orlando, West Virginia, United States
              </h6>
              <span className="timeline__period">Feb 2020 - Apr 2021</span>
              <ul>
                <li>
                  <p className="timeline__description">
                    Reviewed company requirements and created and maintained supporting documentation for project
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Managed schedule for project development and met the deadline of every milestones
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Developed iOS app and built clean apis with firebase functions
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Led a web developer, a backend developer and a designer without any arguments while working
                  </p>
                </li>
              </ul>
            </article>

{/* Blockchain developer */}
            <article className="timeline__item">
              <h5 className="title title--h4 timeline__title">Blockchain Developer</h5>
              <h6 className="title title--h5 timeline__title">
                Amaris • Full-time
              </h6>
              <h6 className="title title--h5 timeline__title">
                Hanoi, Hanoi, Vietnam
              </h6>
              <span className="timeline__period">Feb 2018 – Feb 2020</span>
              <ul>
                <li>
                  <p className="timeline__description">
                    Researched the trending NFT market and tokenomics
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Built several kinds of tokens such as utility, payment, 
                    security and stable tokens, Defi tokens, NFTs and asset-backed tokens
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Devised Test Drive Development (TDD) plans to expand
                    existing capabilities
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Collaborated with scrum team to translate client requirements into implementable user stories
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Developed frontend side for NFT marketplace and integrated smart contract backend using ethers.js
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Led the team of 2 web developers, 2 mobile developers, 1 designer in 3 blockchain projects and tutored 2 junior developers
                  </p>
                </li>
              </ul>
            </article>

{/* Web developer */}
            <article className="timeline__item">
              <h5 className="title title--h4 timeline__title">Web Developer</h5>
              <h6 className="title title--h5 timeline__title">
                Amaris • Full-time
              </h6>
              <h6 className="title title--h5 timeline__title">
                Hanoi, Hanoi, Vietnam
              </h6>
              <span className="timeline__period">Feb 2017 – Feb 2018</span>
              <ul>
                <li>
                  <p className="timeline__description">
                    Maintained and updated Amaris management website
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Built frontend and apis for 4 Ecommerce web apps
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Completed assignments ahead of deadline
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Adhered to industry practices, company standards and safety protocols in work
                  </p>
                </li>
              </ul>
            </article>


            <article className="timeline__item">
              <h5 className="title title--h4 timeline__title">
                Mobile Developer
              </h5>
              <h6 className="title title--h5 timeline__title">
                Hitachi · Full-time
              </h6>
              <h6 className="title title--h5 timeline__title">
                Tokyo, Japan
              </h6>
              <span className="timeline__period">Jan 2014 — Jan 2017</span>
              <ul>
                <li>
                  <p className="timeline__description">
                    Contributed the development of 12 native iOS/Android applications in swift/objective-c and java
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Developed 2 Android applications and 6 iOS applications of them from scratch 
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Explored new technologies and shared findings with the team
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Worked closely with product managers and designers to define rich iOS/Android experience for users
                  </p>
                </li>
                <li>
                  <p className="timeline__description">
                    Gained good communication skills with teammates to support and streamline company policies, procedures and mission
                  </p>
                </li>
              </ul>
            </article>
          </div>

          <h2 className="title title--h2 mt-3">My Skills</h2>
          <div className="box box-inner mb-0">
          <div className="progress">
              <div className="progress-text">
                <span>Blockchain Development</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="87"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '96%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Solidity</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="87"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '94%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Rust</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="87"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '92%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Web3.js/Ethers.js</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="87"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '94%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Go</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="95"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '92%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Javscript</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="93"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '94%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Typescript</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="90"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '91%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Node.js</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="94"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '94%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>React.js</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="92"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '93%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Vue.JS</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="86"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '88%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Swift/Objective-C</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="86"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '96%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>SwiftUI</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="86"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '92%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Java</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="86"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '94%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Kotlin</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="86"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '94%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>React Native</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="86"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '92%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Flutter</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="86"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '86%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>DevOps</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="90"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '90%'}}
                ></span>
              </div>
            </div>

            <div className="progress">
              <div className="progress-text">
                <span>Database</span>
              </div>
              <div className="progress-bar">
                <span
                  role="progressbar"
                  aria-valuenow="89"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{width: '89%'}}
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
